import { IConditionalOptions, AndereErkrankung } from './questionnaire.model';

export const BeschwerdebildOptions: IConditionalOptions[] = [
    {
        label: 'Schmerzen',
        options: [
            "Chronische Schmerzen",
            "Fibromyalgie",
            "Endometriose",
            "Neuropathische Schmerzen",
            "Migräne",
            "Spannungskopfschmerz",
            "Clusterkopfschmerz",
            "Rückenschmerzen",
            "Bandscheibenvorfall",
            "Morbus Crohn",
            "Colitis ulcerosa",
            "Rheuma/rheumatoide Arthritis",
            "Morbus Bechterew",
            "Trigeminusneuralgie",
            "Opioideinsparung",
            AndereErkrankung
        ]
    },
    {
        label: 'Psychische Erkrankungen',
        options: [
            "Tourette-Syndrom/Ticstörungen",
            "PTSD (belastendes Lebensereignis)",
            "Angst",
            "Panikattacken",
            "Depression",
            "Schlafstörungen",
            "ADHS",
            "Anorexia nervosa (Magersucht)",
            "Konzentrationsprobleme",
            "Demenz",
            "Stress",
            "Ermüdung",
            "Zwangsstörungen",
            "Anpassungsstörung",
            "Antriebslosigkeit",
            AndereErkrankung
        ]
    },
    {
        label: 'Neurologische Krankheitsbilder',
        options: [
            "Neuropathische Schmerzen",
            "Migräne",
            "Spannungskopfschmerz",
            "Clusterkopfschmerz",
            "Trigeminusneuralgie",
            "Multiple Sklerose",
            "Parkinson",
            "Restless-Legs-Syndrom",
            "Tinnitus",
            "Long Covid",
            "Chronisches Fatigue-Syndrom (ME/CFS)",
            "Hyperhidrose",
            "Morbus Menière",
            "Plegie oder Parese (Lähmung oder ‘Nervenschäden’)",
            "Epilepsie",
            "Blasenschwäche",
            "Alzheimer",
            "Polyneuropathie",
            "Amyotrophe Lateralsklerose (ALS)",
            "Tremor",
            AndereErkrankung
        ]
    },
    {
        label: 'Frauengesundheit',
        options: [
            "Endometriose",
            "Unterleibsschmerzen im Zusammenhang mit der Periode",
            "Prämenstruelles Syndrom (PMS)",
            "Wechseljahrbeschwerden",
            "Sexuelle Dysfunktion",
            AndereErkrankung
        ]
    },
    {
        label: 'Weitere Erkrankungen',
        options: [
            "Morbus Crohn",
            "Colitis ulcerosa",
            "Long Covid",
            "Chronisches Fatigue-Syndrom (ME/CFS)",
            "Sexuelle Dysfunktion",
            "Krebserkrankung",
            "Chemotherapie-bedingte Übelkeit und Erbrechen",
            "Untergewicht/Appetitlosigkeit/Kachexie",
            "Dystonie",
            "Atemwegserkrankungen",
            "Reizdarmsyndrom",
            "Gastritis (Magenschleimhautentzündung)",
            "Psoriasis (Schuppenflechte)",
            "Neurodermitis",
            "Akne inversa",
            "Rosazea",
            "Kontaktallergie",
            "Unwohlsein",
            "Glaukom",
            AndereErkrankung
        ]
    }
];
